import * as angular from "angular";
import { ConstantItems, getDefaultConfig } from "@constants/shared";
import * as _ from "lodash";
import { ReportDetails } from "@models/portfolioadmin/reportManagement/reportDetails";

export class ReportsRepo {
  static $inject = ["$http", "config"];

  constructor(
    private $http: angular.IHttpService,
    private config: ConstantItems
  ) {}

  getReportTypes() {
    let config = getDefaultConfig();
    return this.$http.get(`${this.config.reportsUrl}/reporttypes`, config);
  }

  getClientReportByType(clientNumber: string, reportType: string) {
    return this.$http
      .get(`${this.config.reportsUrl}/${clientNumber}/${reportType}`)
      .then((resp) => resp.data as ReportDetails[]);
  }

  getCombinedReportsForUser(reportType: string) {
    return this.$http.get(`${this.config.reportsUrl}/users/${reportType}`);
  }

  sendReportEmails(reportId: number) {
    return this.$http.put(`${this.config.reportsUrl}/${reportId}`, {});
  }

  resendReportEmailToSpecificClients(reportId: number, emailIds: number[]) {
    return this.$http.put(
      `${this.config.reportsUrl}/${reportId}/email/resend`,
      emailIds
    );
  }

  sendMultipleReports(clientReportIds: number[], custodianReportIds: number[], recipientUserIds?: number[], recipientCcUserIds?: number[]) {
    const body: { clientReportIds: number[]; custodianReportIds: number[]; recipientUserIds?: number[]; recipientCcUserIds?: number[] } = { clientReportIds, custodianReportIds };
    if (recipientUserIds != null && recipientUserIds.length > 0) {
      body.recipientUserIds = recipientUserIds;
    }
    if (recipientCcUserIds != null && recipientCcUserIds.length > 0) {
      body.recipientCcUserIds = recipientCcUserIds;
    }
    return this.$http.put(
      `${this.config.reportsUrl}/multiple-reports-email`,
      body
    );
  }

  toggleReportLock(reportIds: number[], lockReport: boolean) {
    return this.$http.patch(`${this.config.reportsUrl}/togglelock`, {
      reportIds,
      lock: lockReport,
    });
  }

  uploadCustodianReport = (groupEmailRequest: FormData) => {
    return this.$http.post(
      `${this.config.reportsUrl}/custodians`,
      groupEmailRequest,
      {
        headers: {
          "Content-Type": undefined,
        },
        transformRequest: angular.identity,
      }
    );
  };

  deleteCustodianReport = (id: number) => {
    return this.$http.delete(
      `${this.config.reportsUrl}/custodians/reports/${id}`
    );
  };

  approveCustodianReport = (id: number) => {
    return this.$http.put(
      `${this.config.reportsUrl}/custodians/reports/${id}/approve`,
      true
    );
  };

  unapproveCustodianReport = (id: number) => {
    return this.$http.put(
      `${this.config.reportsUrl}/custodians/reports/${id}/approve`,
      false
    );
  };

  deleteClientReport = (id: number) => {
    return this.$http.delete(
      `${this.config.reportsUrl}/client/reports/${id}`
    );
  };

  getInceptionPerformance(portfolioIds?: Array<number>, date?: string) {
    let queryParams = {
      portfolioIds: portfolioIds,
      date: date,
    };

    let config = getDefaultConfig();
    config.params = queryParams;

    return this.$http.get(
      `${this.config.portfolioUrl}/performance/inception`,
      config
    );
  }

  getCustodianReportsForApproval(quarter: number, year: number, approved?: boolean | null) {
    let queryParams: any = {
      quarter: quarter,
      year: year,
    };

    if (approved !== null && approved !== undefined) {
      queryParams.approved = approved;
    }

    let config = getDefaultConfig();
    config.params = queryParams;

    return this.$http.get(
      `${this.config.reportsUrl}/custodians/approval`,
      config
    );
  }

  bulkApproveCustodianReports(reportIds: number[], approve: boolean = true) {
    return this.$http.put(
      `${this.config.reportsUrl}/custodians/bulk-approve`,
      {
        reportIds: reportIds,
        approve: approve
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/services/reports.repo.ts